import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import {
  PaddingProps,
  paddingFields,
} from '../../../../page-builder/puck/reusable-props/padding';
import {
  JustifyContentField,
  JustifyContentProps,
} from '../../../../page-builder/puck/reusable-props/justify-content';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../../services/constants';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../../puck/reusable-props/widthAndHeight';
import BackgroungColorComponent, {
  IBackgroundProps,
} from '../../customComponents/BackgroungColorComponent';
import ButtonComponent, { ButtonComponentProps } from './ButtonComponent';
import ButtonCommonColor, { ButtonCommonProps } from './ButtonCommon';
import QuantityOptions, { QuantityOptionsProps } from './QuantityOptions';
import { setSelectedVariant } from '../../../redux/slices/postUpsellStateSlice';

export type QuantityProps = {
  border: IBorderValueProps;
  widthAndHeight: WidthAndHeightSubProps;
  background: IBackgroundProps;
  button: ButtonComponentProps;
  leftButton: ButtonCommonProps;
  rightButton: ButtonCommonProps;
  quantity: QuantityOptionsProps;
} & MarginProps &
  PaddingProps &
  JustifyContentProps;

// Commented this file since we use same timer for checkout and upsell
export const QuantityComponent = ({
  useAppSelector,
  useAppDispatch,
}: ReduxSelectorProps & ReduxDispatchProps): ComponentConfig<QuantityProps> => {
  return {
    label: (
      <CustomTooltip title="Quantity">
        <span>Quantity</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        label: 'Border',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      background: {
        type: 'custom',
        label: 'Background',
        render: ({ value, onChange }) => (
          <BackgroungColorComponent
            value={value}
            onChange={onChange}
            title="Background"
          />
        ),
      },
      widthAndHeight: {
        type: 'custom',
        label: 'Width and Height',
        render: ({ value, onChange }) => {
          return (
            <WidthAndHeight
              value={value}
              onChange={onChange}
              title={'Width and Height'}
            />
          );
        },
      },
      ...JustifyContentField,
      quantity: {
        type: 'custom',
        label: 'Quantity',
        render: ({ value, onChange }) => {
          return (
            <QuantityOptions
              value={value}
              onChange={onChange}
              title={'Quantity'}
            />
          );
        },
      },
      button: {
        type: 'custom',
        label: 'Button',
        render: ({ value, onChange }) => {
          return (
            <ButtonComponent
              value={value}
              onChange={onChange}
              title={'Button'}
            />
          );
        },
      },
      leftButton: {
        type: 'custom',
        label: 'Left Button',
        render: ({ value, onChange }) => {
          return (
            <ButtonCommonColor
              value={value}
              onChange={onChange}
              title={'Left Button'}
            />
          );
        },
      },
      rightButton: {
        type: 'custom',
        label: 'Right Button',
        render: ({ value, onChange }) => {
          return (
            <ButtonCommonColor
              value={value}
              onChange={onChange}
              title={'Right Button'}
            />
          );
        },
      },
    },
    defaultProps: {
      margin: {
        deviceType: 'desktop',
        marginBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        marginTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      quantity: {
        showQuantity: true,
        margin: {
          deviceType: 'desktop',
          marginBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },

        background: {
          color: '#ffffff',
          isInherit: false,
        },

        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '10',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '10',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },

        border: { ...borderProps?.border },
      },
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      justifyContent: 'justify-center',
      ...borderProps,
      widthAndHeight: {
        height: {
          desktop: '100%',
          mobile: '100%',
          tablet: '100%',
        },
        maxWidth: {
          desktop: '100%',
          mobile: '100%',
          tablet: '100%',
        },
        deviceType: 'desktop',
      },
      button: {
        margin: {
          deviceType: 'desktop',
          marginBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        boxShadow: 'none',
        border: { ...borderProps?.border },
        width: 'w-auto',
        height: 'h-12',
      },
      leftButton: {
        textcolor: {
          backgroundColor: '#000000',
          hoverColor: '#000000',
        },
        background: {
          backgroundColor: '#FFFFFF',
          hoverColor: '#FFFFFF',
        },
      },
      rightButton: {
        textcolor: {
          backgroundColor: '#000000',
          hoverColor: '#000000',
        },
        background: {
          backgroundColor: '#FFFFFF',
          hoverColor: '#FFFFFF',
        },
      },
    },
    render: ({
      margin,
      padding,
      justifyContent,
      editMode,
      border,
      widthAndHeight,
      background,
      leftButton,
      rightButton,
      button,
      quantity,
    }) => {
      const selectedVariant = useAppSelector(
        state => state.postUpSellState.selectedVariant,
      );
      const dispatch = useAppDispatch();

      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const borderStyles = getBorderProps(border, currentDeviceType);
      const buttonMargin = getNewMarginStyles(
        button?.margin,
        currentDeviceType,
      );
      const buttonPadding = getPaddingStyles(
        button?.padding,
        currentDeviceType,
      );
      const buttonBorderStyles = getBorderProps(
        button?.border,
        currentDeviceType,
      );
      const quantityMarginStyles = getNewMarginStyles(
        quantity?.margin,
        currentDeviceType,
      );
      const quantityPaddingStyles = getPaddingStyles(
        quantity?.padding,
        currentDeviceType,
      );
      const quantityBorderStyles = getBorderProps(
        quantity?.border,
        currentDeviceType,
      );
      const quantityBackgroundStyles = {
        backgroundColor: quantity?.background?.isInherit
          ? 'inherit'
          : quantity?.background?.color,
      };

      const starStyle: React.CSSProperties =
        currentDeviceType &&
        widthAndHeight?.maxWidth &&
        widthAndHeight?.height &&
        widthAndHeight?.maxWidth[currentDeviceType] !== undefined &&
        widthAndHeight?.height[currentDeviceType] !== undefined
          ? {
              width: isNaN(+widthAndHeight?.maxWidth[currentDeviceType])
                ? widthAndHeight?.maxWidth[currentDeviceType]
                : `${+widthAndHeight?.maxWidth[currentDeviceType]}px`,
              height: isNaN(+widthAndHeight?.height[currentDeviceType])
                ? widthAndHeight?.height[currentDeviceType]
                : `${+widthAndHeight?.height[currentDeviceType]}px`,
            }
          : {};

      return (
        <div
          className={`flex ${justifyContent} `}
          style={{
            ...marginStyles,
            ...getPaddingStyles(padding, currentDeviceType),
            ...borderStyles,
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            ...starStyle,
          }}>
          <div>
            <button
              onClick={() => {
                if (Number(selectedVariant?.Quantity) > 1) {
                  dispatch(
                    setSelectedVariant({
                      ...selectedVariant,
                      Quantity: (Number(selectedVariant?.Quantity) || 0) - 1,
                    }),
                  );
                }
              }}
              className={`${button?.height} ${button?.width} ${button?.boxShadow} `}
              style={{
                // backgroundColor: leftButton?.background?.backgroundColor,
                ...buttonMargin,
                ...buttonBorderStyles,
                ...buttonPadding,
                lineHeight: 1.5,
                transition: 'background-color 0.3s',
                background: leftButton?.background?.backgroundColor,
                color: leftButton?.textcolor?.backgroundColor,
              }}
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor =
                  leftButton?.background?.hoverColor;
                e.currentTarget.style.color = leftButton?.textcolor?.hoverColor;
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor =
                  leftButton?.background?.backgroundColor;
                e.currentTarget.style.color =
                  leftButton?.textcolor?.backgroundColor;
              }}>
              -
            </button>
            {quantity?.showQuantity ? (
              <span
                style={{
                  ...quantityMarginStyles,
                  ...quantityPaddingStyles,
                  ...quantityBorderStyles,
                  ...quantityBackgroundStyles,
                }}>
                {selectedVariant?.Quantity}
              </span>
            ) : null}
            <button
              onClick={() => {
                dispatch(
                  setSelectedVariant({
                    ...selectedVariant,
                    Quantity: (Number(selectedVariant?.Quantity) || 0) + 1,
                  }),
                );
              }}
              className={`${button?.height} ${button?.width} ${button?.boxShadow} `}
              style={{
                background: rightButton?.background?.backgroundColor,
                color: rightButton?.textcolor?.backgroundColor,
                ...buttonMargin,
                ...buttonBorderStyles,
                ...buttonPadding,
                lineHeight: 1.5,
                transition: 'background-color 0.3s',
              }}
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor =
                  rightButton?.background?.hoverColor;
                e.currentTarget.style.color =
                  rightButton?.textcolor?.hoverColor;
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor =
                  rightButton?.background?.backgroundColor;
                e.currentTarget.style.color =
                  rightButton?.textcolor?.backgroundColor;
              }}>
              +
            </button>
          </div>
        </div>
      );
    },
  };
};
